__turbopack_context__.v({
  "richText": "_9q8ilW_richText",
});
